module.exports = __webpack_public_path__ + "static/img/7363_phase_function_Paper_PointsHejduk_Prediction.edae392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7363_phase_function_Paper_PointsHejduk_Prediction.png
// module id = wa0q
// module chunks = 0